import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { BoxesInterface } from '../../widget-photos-teaser-circle.props';
import SrcSet from '../../../../../components/src-set/src-set';
import getLinkRelByTarget from 'helpers/get-link-rel-by-target';

import './widget-photos-teaser-circle-boxes.scss';

interface WidgetPhotosTeaserCircleBoxesInterface {
    boxes: BoxesInterface[];
}

const WidgetPhotosTeaserCircleBoxes: React.FC<WidgetPhotosTeaserCircleBoxesInterface> = ({ boxes }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';

    return (
        <div className="boxes">
            <div className="boxes__list">
                { boxes.map((item, idx) => (
                    <a
                        className="boxes__list__item"
                        href={item.url}
                        key={item.img}
                        target={item.target}
                        rel={getLinkRelByTarget(item.target)}
                    >
                        <div className="boxes__list__item__image">
                            <picture>
                                <SrcSet
                                    images={item.modifiedImg}
                                    alt={item.alt.trim() || `Obrazek ${idx}`}
                                    isMobile={isMobile}
                                />
                            </picture>
                        </div>
                        <div className="boxes__list__item__cta">
                            {item.cta}
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default WidgetPhotosTeaserCircleBoxes;
